<template>
  <div>
    <tasks-template ref="tasks" tool="inspector"> </tasks-template>
    <floating-repair-select @open="openChatBox" />
  </div>
</template>

<script>
import TaskTemplate from '../ToolsTemplates/TaskPage';
import FloatingRepairSelect from '../Shared/FloatingRepairSelect';
import WorkOrderListStrategy from '../ChatBox/strategies/WorkOrderListStrategy';
import store from '../../store/index';
import JobViewMixin from '../../mixins/Shared/JobViewMixin';

export default {
  components: {
    'tasks-template': TaskTemplate,
    FloatingRepairSelect,
  },
  mixins: [JobViewMixin],
  async beforeRouteEnter(to, {}, next) {
    const { id } = to.params;
    // const { state } = store;
    // Necessary until migration to vue
    // if (!state.job || state.job.id !== id) {
    await store.dispatch('getJob', id);
    // }
    next();
  },
  methods: {
    openChatBox() {
      this.$chatbox.open({
        strategy: new WorkOrderListStrategy(),
      });
    },
  },

  // TODO: After testing in QA remove this commented code
  // async beforeRouteLeave({}, {}, next) {
  //   if (this.$refs.tasks.job.taskCount !== this.$refs.tasks.tasks.length) {
  //     this.$refs.tasks.job.taskCount = this.$refs.tasks.tasks.length;
  //     await this.$store.dispatch('updateJobSimple', this.$refs.tasks.job);
  //   }

  //   const waitForUpdate = setInterval(() => {
  //     if (!this.$store.state.waitingForWrite) {
  //       clearInterval(waitForUpdate);
  //       next();
  //     }
  //   }, 1000);
  // },
};
</script>

<style></style>
